import { SxProps } from '@mui/material';
import { Dayjs } from 'dayjs';
import palette from 'styles/theme/Palette';

const primary = palette.primary.main;

const MONTHS_IN_YEAR = 12;

const pillStyle = {
	backgroundColor: 'white!important',
	borderRadius: '16px!important',
	border: `2px solid ${primary}!important`,
	color: `${primary}!important`,
};

const inRangeRootStyle = { backgroundColor: primary };

const inRangeBtnStyle = {
	backgroundColor: 'transparent!important',
	borderRadius: '0!important',
	color: 'white!important',
};

const stripeRight = {
	background: `linear-gradient(to right, transparent 50%, ${primary} 50%)`,
};

const stripeLeft = {
	background: `linear-gradient(to right, ${primary} 50%, transparent 50%)`,
};

/**
 * Computes the visible range boundaries for the current year view.
 * Returns [effectiveStart, effectiveEnd] or null if no range is visible.
 */
const getVisibleRange = (
	startMonth: number,
	startYear: number,
	endMonth: number,
	endYear: number,
	currentViewYear: number,
): [number, number] | null => {
	if (currentViewYear > startYear && currentViewYear < endYear) {
		return [0, 11];
	}
	if (currentViewYear === startYear && currentViewYear === endYear) {
		return [startMonth, endMonth];
	}
	if (currentViewYear === startYear && currentViewYear < endYear) {
		return [startMonth, 11];
	}
	if (currentViewYear > startYear && currentViewYear === endYear) {
		return [0, endMonth];
	}
	return null;
};

const getMonthRangeStyles = (
	dateStart: Dayjs | null,
	dateEnd: Dayjs | null,
	currentViewYear: number,
): SxProps => {
	if (!dateStart) return {};

	const startYear = dateStart.year();
	const startMonth = dateStart.month();
	const hasEnd = dateEnd !== null;
	const endYear = dateEnd?.year() ?? null;
	const endMonth = dateEnd?.month() ?? null;

	const visibleRange =
		hasEnd && endYear !== null && endMonth !== null
			? getVisibleRange(startMonth, startYear, endMonth, endYear, currentViewYear)
			: null;

	const isStartVisible = startYear === currentViewYear;
	const isEndVisible = hasEnd && endYear === currentViewYear;

	const styles: Record<string, object> = {};

	for (let i = 0; i < MONTHS_IN_YEAR; i++) {
		const root = `& .MuiPickersMonth-root:nth-of-type(${i + 1})`;
		const btn = `${root} .MuiPickersMonth-monthButton`;

		const isStart = isStartVisible && i === startMonth;
		const isEnd = isEndVisible && i === endMonth;
		const isInRange =
			visibleRange !== null &&
			(isStartVisible ? i > visibleRange[0] : i >= visibleRange[0]) &&
			(isEndVisible ? i < visibleRange[1] : i <= visibleRange[1]);

		if (isStart && hasEnd) {
			styles[root] = stripeRight;
			styles[btn] = pillStyle;
		} else if (isStart) {
			styles[btn] = pillStyle;
		} else if (isEnd) {
			styles[root] = stripeLeft;
			styles[btn] = pillStyle;
		} else if (isInRange) {
			styles[root] = inRangeRootStyle;
			styles[btn] = inRangeBtnStyle;
		}
	}

	return styles;
};

export default getMonthRangeStyles;
